
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1300 800","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{staticClass:"i-sun",attrs:{"cx":"650","cy":"400","rx":"274.505","ry":"275.329","fill":"#fff"}}),_c('path',{staticClass:"i-venus",attrs:{"d":"M962.931 241.189a350.926 350.926 0 0 1-79.336 420.689 350.917 350.917 0 0 1-132.902 74.288l-21.571-72.015a275.734 275.734 0 0 0 174.31-155.484 275.742 275.742 0 0 0-7.538-233.457l67.037-34.021Z","fill":"#73D6D3"}}),_c('path',{staticClass:"i-mercury",attrs:{"d":"M317.791 400a332.209 332.209 0 0 1 47.381-170.985l49.218 29.546A274.802 274.802 0 0 0 375.196 400h-57.405Z","fill":"#92B8B8"}})])
          )
        }
      }
    